<ul class="list-container">
  <div class="container-loader doc-outline" *ngIf="isBusy">
    <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
  </div>
  <li *ngFor="let item of documentOutlineList" class="list-item">
    <ng-container *ngTemplateOutlet="content; context: {item: item}"></ng-container>
  </li>
</ul>

<ng-template #content let-item="item">
  <!-- if got child -->
  <ng-container *ngIf="item.ChildCount > 0; else noChild">
    <input type="checkbox" id="{{ 'cb-' + item.ItemId }}">
    <label for="{{ 'cb-' + item.ItemId }}" (click)="getChild(item.ItemId)"></label>
    <div class="view-parent" (click)="selectItem(item.ItemId)" [class.disabled]="isDisabled">
      <span class="view-item" [ngClass]="{'active': selectedItemId == item.ItemId, 'menuOpen': currentItem == item.ItemId}">
        {{ item.ItemDisplay }}
      </span>
      <span [ngClass]="{'utter-icon': true, 'menuOpen': currentItem == item.ItemId}" (click)="onContextMenu($event, item)"><i class="fa fa-ellipsis-v"></i></span>
    </div>
    <div class="clearfix"></div>
    <app-document-outline class="child-container" [setChildComponentId]="componentId" [setDocumentOutline]="item.ChildList" (selectedItem)="onSelectedItem($event)"></app-document-outline>
  </ng-container>

  <!-- if got no child -->

  <ng-template #noChild>
    <div class="view-parent" (click)="selectItem(item.ItemId)" [class.disabled]="isDisabled">
      <span [ngClass]="{'view-item': true, 'active': selectedItemId == item.ItemId, 'menuOpen': currentItem == item.ItemId}">
        {{ item.ItemDisplay }}
      </span>
      <span [ngClass]="{'utter-icon': true, 'menuOpen': currentItem == item.ItemId}" (click)="onContextMenu($event, item)"><i class="fa fa-ellipsis-v"></i></span>
    </div>
    <div class="clearfix"></div>
  </ng-template>
</ng-template>

<context-menu [useBootstrap4]="true" (close)="onCloseContextMenu()">
  <ng-template contextMenuItem (execute)="pullPopup($event.item)">
    Add Quick Phrase
  </ng-template>
</context-menu>